export default function SwapIcon() {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.875 2.375L16.25 6.75L11.875 11.125'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M15.5809 6.75H3.75' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M8.125 18.625L3.75 14.25L8.125 9.875'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M4.45312 14.25H16.25' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export function SwapSuccessIcon() {
  return (
    <svg width='42' height='43' viewBox='0 0 42 43' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='40' height='40' rx='20' fill='#FBFBFB' fillOpacity='0.1' />
      <path
        d='M21.875 12.375L26.25 16.75L21.875 21.125'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M25.5809 16.75H13.75' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M18.125 28.625L13.75 24.25L18.125 19.875'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M14.4531 24.25H26.25' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <rect x='25.4167' y='26.4167' width='15.1667' height='15.1667' rx='7.58333' fill='#60B18A' />
      <rect
        x='25.4167'
        y='26.4167'
        width='15.1667'
        height='15.1667'
        rx='7.58333'
        stroke='#101013'
        strokeWidth='1.16667'
      />
      <path
        d='M36.8081 32.2689L32.1414 36.9356C32.1007 36.9764 32.0524 37.0087 31.9993 37.0308C31.9461 37.0529 31.8891 37.0643 31.8315 37.0643C31.7739 37.0643 31.7169 37.0529 31.6637 37.0308C31.6105 37.0087 31.5622 36.9764 31.5216 36.9356L29.4799 34.8939C29.4392 34.8532 29.4069 34.8049 29.3849 34.7517C29.3629 34.6986 29.3516 34.6416 29.3516 34.584C29.3516 34.5265 29.3629 34.4695 29.3849 34.4163C29.4069 34.3631 29.4392 34.3148 29.4799 34.2741C29.5206 34.2334 29.5689 34.2011 29.6221 34.1791C29.6753 34.1571 29.7323 34.1458 29.7898 34.1458C29.8474 34.1458 29.9044 34.1571 29.9575 34.1791C30.0107 34.2011 30.059 34.2334 30.0997 34.2741L31.8319 36.0063L36.189 31.6498C36.2712 31.5677 36.3826 31.5215 36.4989 31.5215C36.6151 31.5215 36.7266 31.5677 36.8088 31.6498C36.891 31.732 36.9371 31.8435 36.9371 31.9597C36.9371 32.076 36.891 32.1874 36.8088 32.2696L36.8081 32.2689Z'
        fill='#010101'
      />
    </svg>
  )
}

export function SwapPendingIcon() {
  return (
    <svg width='42' height='43' viewBox='0 0 42 43' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='40' height='40' rx='20' fill='#FBFBFB' fillOpacity='0.1' />
      <path
        d='M21.875 12.375L26.25 16.75L21.875 21.125'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M25.5809 16.75H13.75' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M18.125 28.625L13.75 24.25L18.125 19.875'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M14.4531 24.25H26.25' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <rect x='25.4167' y='26.4167' width='15.1667' height='15.1667' rx='7.58333' fill='#E69B39' />
      <rect
        x='25.4167'
        y='26.4167'
        width='15.1667'
        height='15.1667'
        rx='7.58333'
        stroke='#101013'
        strokeWidth='1.16667'
      />
      <path
        d='M35.625 32.0917V30.7923C35.625 30.6376 35.5635 30.4892 35.4541 30.3798C35.3447 30.2704 35.1964 30.209 35.0417 30.209H30.9583C30.8036 30.209 30.6553 30.2704 30.5459 30.3798C30.4365 30.4892 30.375 30.6376 30.375 30.7923V32.1048C30.3752 32.1953 30.3964 32.2846 30.4369 32.3656C30.4773 32.4465 30.536 32.517 30.6083 32.5715L32.514 34.0007L30.6083 35.4298C30.536 35.4843 30.4773 35.5548 30.4369 35.6357C30.3964 35.7167 30.3752 35.806 30.375 35.8965V37.209C30.375 37.3637 30.4365 37.5121 30.5459 37.6215C30.6553 37.7309 30.8036 37.7923 30.9583 37.7923H35.0417C35.1964 37.7923 35.3447 37.7309 35.4541 37.6215C35.5635 37.5121 35.625 37.3637 35.625 37.209V35.9096C35.6248 35.8194 35.6038 35.7305 35.5636 35.6498C35.5235 35.569 35.4653 35.4986 35.3935 35.444L33.4838 34.0007L35.3935 32.5569C35.4653 32.5024 35.5236 32.4321 35.5637 32.3514C35.6039 32.2707 35.6248 32.1818 35.625 32.0917ZM35.0417 37.209H30.9583V35.8965L33 34.3652L35.0417 35.9092V37.209ZM35.0417 32.0917L33 33.6361L30.9583 32.1048V30.7923H35.0417V32.0917Z'
        fill='black'
      />
    </svg>
  )
}

export function SwapFailedIcon() {
  return (
    <svg width='42' height='43' viewBox='0 0 42 43' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='40' height='40' rx='20' fill='#FBFBFB' fillOpacity='0.1' />
      <path
        d='M21.875 12.375L26.25 16.75L21.875 21.125'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M25.5809 16.75H13.75' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M18.125 28.625L13.75 24.25L18.125 19.875'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M14.4531 24.25H26.25' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <rect x='25.4167' y='26.4167' width='15.1667' height='15.1667' rx='7.58333' fill='#E04D4D' />
      <rect
        x='25.4167'
        y='26.4167'
        width='15.1667'
        height='15.1667'
        rx='7.58333'
        stroke='#101013'
        strokeWidth='1.16667'
      />
      <path
        d='M30.75 31.75L35.25 36.25M35.25 31.75L30.75 36.25'
        stroke='black'
        strokeWidth='0.8'
        strokeLinecap='round'
      />
    </svg>
  )
}
